import React from 'react';

function Account() {
  return (
    <div className="account">
      <h2>Account Page</h2>
      <p>This is the account page. Add your account-related content here.</p>
    </div>
  );
}

export default Account;
